const TeamData = {
    doctors: [
        {
            id: 1,
            imgUrl: "d1.png",
            name: "Darry Milin",
            position: "Oral Surgeon",
            link: "/Page/DentistDetails",
            socialIcon: [
                {
                    id: 1,
                    url: 'https://www.facebook.com/',
                    icon: 'fab fa-facebook-f',
                },
                {
                    id: 2,
                    url: '.#',
                    icon: 'fab fa-twitter',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-whatsapp',
                },
                {
                    id: 4,
                    url: '.#',
                    icon: 'fab fa-linkedin-in',
                }
            ],
        },
        {
            id: 2,
            imgUrl: "d2.png",
            name: "Salman Ahmed",
            position: "Oral Surgeon",
            link: "/Page/DentistDetails",
            socialIcon: [
                {
                    id: 1,
                    url: 'https://www.facebook.com/',
                    icon: 'fab fa-facebook-f',
                },
                {
                    id: 2,
                    url: '.#',
                    icon: 'fab fa-twitter',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-linkedin-in',
                },
                {
                    id: 4,
                    url: '.#',
                    icon: 'fab fa-skype',
                }
            ],
        },
        {
            id: 3,
            imgUrl: "d3.png",
            name: "Santa Binte",
            position: "Oral Surgeon",
            link: "/Page/DentistDetails",
            socialIcon: [
                {
                    id: 1,
                    url: 'https://www.facebook.com/',
                    icon: 'fab fa-facebook-f',
                },
                {
                    id: 2,
                    url: '.#',
                    icon: 'fab fa-twitter',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-linkedin-in',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-youtube',
                }
            ],
        },
        {
            id: 4,
            imgUrl: "d2.png",
            name: "Shahin Ahmed",
            position: "Oral Surgeon",
            link: "/Page/DentistDetails",
            socialIcon: [
                {
                    id: 1,
                    url: 'https://www.facebook.com/',
                    icon: 'fab fa-facebook-f',
                },
                {
                    id: 2,
                    url: '.#',
                    icon: 'fab fa-twitter',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-linkedin-in',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-youtube',
                }
            ],
        },
        {
            id: 5,
            imgUrl: "d3.png",
            name: "Salma Jahan",
            position: "Oral Surgeon",
            link: "/Page/DentistDetails",
            socialIcon: [
                {
                    id: 1,
                    url: 'https://www.facebook.com/',
                    icon: 'fab fa-facebook-f',
                },
                {
                    id: 2,
                    url: '.#',
                    icon: 'fab fa-twitter',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-linkedin-in',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-whatsapp',
                }
            ],
        },
        {
            id: 6,
            imgUrl: "d1.png",
            name: "Rasel Ahmed",
            position: "Oral Surgeon",
            link: "/Page/DentistDetails",
            socialIcon: [
                {
                    id: 1,
                    url: 'https://www.facebook.com/',
                    icon: 'fab fa-facebook-f',
                },
                {
                    id: 2,
                    url: '.#',
                    icon: 'fab fa-twitter',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-linkedin-in',
                },
                {
                    id: 3,
                    url: '.#',
                    icon: 'fab fa-skype',
                }
            ],
        }
    ],

}


export default TeamData
